import React from "react";
import "./styles.css";
function Footer() {
  return (
    <div className="footer">
      <p>Copyright @ All rights reserved.</p>
    </div>
  );
}
export default Footer;